<div class="container-fluid h-100">
  <div class="row h-100">
    <div class="col-12 p-0 h-100">
      <div class="h-100 text-center m-0 d-flex flex-column justify-content-center">
        <span [ngClass]="faSize + ' ' + color"><i class="fas fa-sync fa-spin"></i></span>
      </div>
    </div>
  </div>
</div>
